/**
 * This needs to stay as JS because it's imported into the tailwind.config.js file
 */

// this object matches 1:1 the colors that exist in our figma designs
const FIGMA_COLORS = {
  blue: {
    DEFAULT: '#6491FF',
    200: '#84A7FF',
    300: '#99B6FF',
    400: '#C3D5FF',
    500: '#EBF1FF',
    focused: '#5581F2',
    hover: '#4E76D6',
    active: '#4164BB',
  },
  black: {
    DEFAULT: '#474747',
    200: '#5C5C5C',
    300: '#858585',
    400: '#B6B6B6',
  },
  grey: {
    DEFAULT: '#D7D7D7',
    200: '#E0E0E0',
    300: '#EBEBEB',
    400: '#F5F5F5',
    500: '#FAFAFA',
  },
  white: {
    DEFAULT: '#FFFFFF',
  },
  green: {
    DEFAULT: '#00C896',
    200: '#00E0A8',
    300: '#78EDBC',
    400: '#A6F8D5',
    500: '#CAFCE7',
  },
  red: {
    DEFAULT: '#FF5F69',
    200: '#FF858D',
    300: '#FF99A0',
    400: '#FFADB3',
    500: '#FFE1E3',
  },
  yellow: {
    DEFAULT: '#FFE164',
    200: '#FFE785',
    300: '#FFEB99',
    400: '#FFF5CA',
    500: '#FFFAE8',
    deep: '#FFCE00',
  },
  purple: {
    DEFAULT: '#AF87E1',
    200: '#BE9DE7',
    300: '#C9ADEB',
    400: '#DFCEF3',
    500: '#E9DEF7',
  },
  lightBlue: {
    DEFAULT: '#91EBFA',
    200: '#B1F0FB',
    300: '#C5F4FC',
    400: '#D8F8FD',
    500: '#ECFBFE',
  },
  blueStates: {
    focused: '#5581F2',
    hover: '#4E76D6',
    active: '#4164BB',
  },
  lightGreen: {
    DEFAULT: '#AAEB78',
    200: '#BCEF95',
    300: '#C7F2A6',
    400: '#D2F4B8',
    500: '#DDF7CA',
  },
  orange: {
    DEFAULT: '#FFA02D',
    200: '#FFAC47',
    300: '#FFB65C',
    400: '#FFCE91',
    500: '#FFE2BE',
  },
}

const lightTheme = {
  colors: {
    black: FIGMA_COLORS.black,
    white: FIGMA_COLORS.white,
    blue: FIGMA_COLORS.blue,
    green: FIGMA_COLORS.green,
    grey: FIGMA_COLORS.grey,
    lightBlue: FIGMA_COLORS.lightBlue,
    lightGreen: FIGMA_COLORS.lightGreen,
    orange: FIGMA_COLORS.orange,
    purple: FIGMA_COLORS.purple,
    red: FIGMA_COLORS.red,
    yellow: FIGMA_COLORS.yellow,
  },
}

module.exports = {
  lightTheme,
}
